import { atom } from 'recoil';
import { GaitSession } from '@/common/types';

export const GaitSessionsState = atom<GaitSession[]>({
    key: 'gaitSessions',
    default: [],
});
